module.exports = __webpack_public_path__ + "static/media/closed-page.d767a80f.png";